import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Container from 'common/Container';
import {
  Hero,
  Ecosystem,
  Products,
  ProductionMaterials,
  WhySection,
  InvestmentSummary,
  AreYouReady,
} from './components';

const LandingMediaKitPapaupa = ({ themeMode = 'light' }) => (
  <Box>
    <Container>
      <Hero themeMode={themeMode} />
    </Container>
    <Container>
      <Ecosystem />
    </Container>
    <Container>
      <Products />
    </Container>
    <Container>
      <InvestmentSummary />
    </Container>
    <Container>
      <ProductionMaterials />
    </Container>
    <Container>
      <WhySection />
    </Container>
    <Container>
      <AreYouReady />
    </Container>
  </Box>
);

LandingMediaKitPapaupa.propTypes = {
  themeMode: PropTypes.string,
};

export default LandingMediaKitPapaupa;
